import React from "react";
import { array, bool, string } from "prop-types";

import CustomStoryCard4 from "../../../../molecules/CustomStoryCard4";

import "./organism2.m.css";

const Organism2 = ({ stories, updatedFont, src }) => (
  <div styleName="base">
    {stories.map(({ story }, index) => (
      <CustomStoryCard4
        story={story}
        key={index}
        headlineType={37}
        showStoryMetaInfo={true}
        updatedFont={updatedFont}
        src={src}
      />
    ))}
  </div>
);

Organism2.propTypes = {
  stories: array.isRequired,
  updatedFont: bool,
  src: string,
};

export default Organism2;
